import { useRateParameters } from '@/api/models/requests/hooks/useRateParameters'
import { AppModal } from '@/components/shared/modal'
import { MODAL_TITLE_ERROR } from '@/utils/constants'

import { AddRatingForm } from './AddRatingForm'
import { FeedbackCompletedContent } from './FeedbackCompletedContent'
import {
  MODAL_TITLE_ADD_RATING,
  MODAL_TITLE_PROBLEM_NOT_SOLVED
} from './model/constants'
import { ProblemNotSolvedForm } from './ProblemNotSolvedForm'
import { RequestRatingHeader } from './RequestRatingHeader'
import { ModalName } from './types/types'

type Props = {
  id: string
  isButtonUnsolvedAvailable: boolean
  modalName: ModalName | null
  onClose: () => void
  setModalName: (_: ModalName) => void
  refetchRequest: () => void
}

const RequestRatingMobileModal = ({
  id,
  isButtonUnsolvedAvailable,
  modalName,
  onClose,
  setModalName,
  refetchRequest
}: Props) => {
  const {
    data: rateParameters,
    isLoading: areRateParametersLoading,
    isError: isRateParametersError,
    error: rateParametersError
  } = useRateParameters()

  const addRatingTitle = isRateParametersError
    ? MODAL_TITLE_ERROR
    : MODAL_TITLE_ADD_RATING

  return (
    <AppModal
      header={
        <>
          {modalName === ModalName.AddRating && (
            <RequestRatingHeader
              title={addRatingTitle}
              onClose={onClose}
              isMobile
            />
          )}
          {modalName === ModalName.ProblemNotSolved && (
            <RequestRatingHeader
              title={MODAL_TITLE_PROBLEM_NOT_SOLVED}
              onClose={onClose}
              isMobile
            />
          )}
          {modalName === ModalName.FeedbackCompleted && (
            <RequestRatingHeader
              onClose={onClose}
              isMobile
              className="hidden xs:flex"
            />
          )}
        </>
      }
      className={
        modalName === ModalName.FeedbackCompleted ? 'w-[480px]' : undefined
      }
      opened={modalName !== null}
      onClose={onClose}
    >
      {modalName === ModalName.AddRating && (
        <AddRatingForm
          id={id}
          isButtonUnsolvedAvailable={isButtonUnsolvedAvailable}
          onClose={onClose}
          setModalName={setModalName}
          refetchRequest={refetchRequest}
          rateParameters={rateParameters}
          areRateParametersLoading={areRateParametersLoading}
          isRateParametersError={isRateParametersError}
          rateParametersError={rateParametersError}
        />
      )}
      {modalName === ModalName.ProblemNotSolved && (
        <ProblemNotSolvedForm
          id={id}
          onClose={onClose}
          setModalName={setModalName}
          refetchRequest={refetchRequest}
        />
      )}
      {modalName === ModalName.FeedbackCompleted && (
        <FeedbackCompletedContent onClose={onClose} />
      )}
    </AppModal>
  )
}

export { RequestRatingMobileModal }
